<template lang="pug">
div(
    :class="classes"
)
    IconBase(
        :name="name"
        :size="40"
        :color="iconView"
    )
</template>

<script lang="ts">
import { computed, defineComponent, PropType, toRefs, useCssModule } from 'vue'

import { IconBase, IconName } from '../IconBase'

import { views } from './model'

export type IconViewResponseProps = {
    view: (typeof views)[number]
    name: IconName
}

export default defineComponent({
    name: 'IconViewResponse',
    components: { IconBase },
    props: {
        view: {
            type: String as PropType<IconViewResponseProps['view']>,
            required: true,
        },
        name: {
            type: String as PropType<IconViewResponseProps['name']>,
            required: true,
        },
    },
    setup(props) {
        const { view } = toRefs(props)
        const styles = useCssModule()

        const classes = computed(() => [
            styles.root,
            styles[`view_${view.value}`],
        ])

        const iconView = computed(() => {
            if (view.value === 'default') {
                return 'foreground400'
            }

            if (view.value === 'success') {
                return 'successForeground'
            }

            return 'dangerForeground'
        })

        return {
            classes,
            iconView,
        }
    },
})
</script>

<style module lang="scss" src="./IconViewResponse.module.scss" />
